import React, { Component } from 'react';
import i18n from "i18next";

class FormTextIncomplete extends Component {
    render() {
        return (
            <div className="form-row form-row--help --incomplete">
                <span className="form-row--help__text">{i18n.t("form_suggestions.incomplete")}</span>
            </div>
        )
    }
}

export default FormTextIncomplete;
